export const LoadMetricKeys: any = {
	tti: 'metric:tti',
	fmp: 'metric:fmp',
	ttiHistograms: 'metric:tti:histogramBuckets',
	fmpHistograms: 'metric:fmp:histogramBuckets',
};
